<template>
  <div
    v-if="routeName === 'WebCall' && screenWidth >= 600 ? false : true"
    class="corp-header--mobile"
  >
    <v-toolbar-items>
      <DropdownCompany />

      <v-spacer />

      <DropdownUser />
    </v-toolbar-items>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DropdownCompany from 'components/corpHeader/DropdownCompany'
import DropdownUser from 'components/corpHeader/DropdownUser'

export default {
  name: 'MobileHeader',
  props: {
    screenWidth: {
      type: Number
    }
  },
  components: {
    DropdownCompany,
    DropdownUser
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    }),

    routeName () {
      return this.$route.name
    }
  },
  methods: {
    resetPassword () {
      this.$emit('resetPassword')
    },

    logoutSession () {
      this.$emit('logoutSession')
    }
  }
}
</script>

<style lang="scss">
.corp-header--mobile {
  background-color: #fff;
  border-bottom: 1px solid $gray-4;
  height: 64px;
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;

  @media (min-width: 768px) {
    display: none;
  }

  .dropdown-custom__container .dropdown-custom__list {
    right: auto;
    left: 0;
    min-width: 320px;
  }
}

.reset-company {
  border-top: 1px solid $gray-4;
  cursor: pointer;
  overflow: hidden;

  .v-list__tile__content {
    height: 52px;
  }

  .v-list__tile__title {
    font-size: 14px;
    height: 52px;
    line-height: 1.8;
    padding: 15px 16px;

    &:hover {
      background: rgba(0,0,0,0.04);
    }
  }
}
</style>
